import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    divAlunoResponsavel: {
        border: '1px solid black',
        padding: '15px',
        marginBottom: '8px',
        borderRadius: '20px',
    }
});

const AlunoResponsavelCard = ({ alunoResponsavel }) => {
    const classes = useStyles();
    return (
        <div className={classes.divAlunoResponsavel}>
            <Typography>
                {alunoResponsavel.usuario.nome} - {alunoResponsavel.parentesco.descricao}
            </Typography>
            <Typography>
                {alunoResponsavel.aluno.nome}
            </Typography>
        </div>
    );
}

export default AlunoResponsavelCard;